import { render, staticRenderFns } from "./TheHints.vue?vue&type=template&id=1b25e894&scoped=true&"
import script from "./TheHints.vue?vue&type=script&lang=js&"
export * from "./TheHints.vue?vue&type=script&lang=js&"
import style0 from "./TheHints.vue?vue&type=style&index=0&id=1b25e894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b25e894",
  null
  
)

export default component.exports